import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { history } from "../store";

import { Modal, ModalError } from "../features";
import { Box } from "@material-ui/core";

import Routes from "./Routes";
import { ModalDouble } from "../features/modals";

function CoreNavigation() {
  return (
    <ConnectedRouter history={history}>
      <Box bgcolor="background.paper" height="100%" overflow="hidden">
        <Routes />
      </Box>
      <ModalDouble />
      <Modal />
      <ModalError />
    </ConnectedRouter>
  );
}

export default React.memo(CoreNavigation);
